import { NotificationManager } from 'react-notifications';
import {
   GET_CONFIG,
   SET_CONFIG,
   FETCH_SERVICE_VISIBILITY_CONFIG,
   UPDATE_SERVICE_VISIBILITY_CONFIG
} from './types';
import api from '@/utils/api';
import { registerServiceGroups } from '@/utils/serviceGroups';

export const getConfig = () => dispatch => {
    return api.get('/config/get').then(res => {
        registerServiceGroups(res.data.data?.service_groups);
        dispatch({type: GET_CONFIG, payload: res.data.data})
    }).catch(err => {
        console.log(err);
    })
}

export const setConfig = (data) => dispatch => {
    return api.post('/config/update', data).then(res => {
        dispatch({type: SET_CONFIG});
        NotificationManager.success("Cập nhật thành công");
    }).catch(err => {
        console.log(err);
    })
}

export const fetchServiceVisibilityConfig = () => dispatch => {
    return api.get('/config/service-visibility').then(res => {
        dispatch({ type: FETCH_SERVICE_VISIBILITY_CONFIG, payload: res.data.data });
        return res.data.data;
    }).catch(err => {
        NotificationManager.error(err.response?.data?.msg || 'Không thể tải cấu hình ẩn dịch vụ');
        throw err;
    });
};

export const updateServiceVisibilityToggle = (enabled, version) => dispatch => {
    return api.put('/config/service-visibility/toggle', { enabled, version }).then(res => {
        dispatch({ type: UPDATE_SERVICE_VISIBILITY_CONFIG, payload: res.data.data });
        NotificationManager.success(res.data.msg || 'Cập nhật chế độ lọc thành công');
        return res.data.data;
    }).catch(err => {
        NotificationManager.error(err.response?.data?.msg || 'Không thể cập nhật chế độ lọc');
        throw err;
    });
};

export const updateServiceVisibilityItems = (items, version) => dispatch => {
    return api.put('/config/service-visibility/services', { items, version }).then(res => {
        dispatch({ type: UPDATE_SERVICE_VISIBILITY_CONFIG, payload: res.data.data });
        NotificationManager.success(res.data.msg || 'Lưu cấu hình ẩn dịch vụ thành công');
        return res.data.data;
    }).catch(err => {
        NotificationManager.error(err.response?.data?.msg || 'Không thể lưu cấu hình ẩn dịch vụ');
        throw err;
    });
};
